import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificacionService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'notification-header',
  templateUrl: './notification-header.component.html',
  styleUrls: ['./notification-header.component.scss'],
})
export class NotificationHeaderComponent implements OnInit {
  constructor(
    private readonly notificationsService: NotificacionService,
    private readonly router:Router
    ) {}

  ngOnInit() {}

  showAll(){
    this.router.navigate(['/notifications']);	
  }

  getData(event) {
    let type = event?.checked ? 'unreads' : 'all';
    this.notificationsService.updatedNotifications.next(type);
  }
}
